
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const BeforeAfterPage = lazy(() => import('../pages/before-after/page'));
const ArchitectsPage = lazy(() => import('../pages/architects/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/projects',
    element: <ProjectsPage />,
  },
  {
    path: '/before-after',
    element: <BeforeAfterPage />,
  },
  {
    path: '/architects',
    element: <ArchitectsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
